/* eslint-disable
    max-len,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
require('./confirmAddNotesDialog.scss');

const deps = [require('ui/web/modal').name];

module.exports = angular
  .module('bench.component.confirmAddNotesDialog', deps)

  .service('blConfirmAddNotesService', ngDialog => ({
    openConfirm(message, confirmText = 'Confirm', cancelText = 'Cancel', template) {
      return ngDialog.openConfirm({
        className: 'bl-confirmAddNotes',
        plain: true, // use plain string as template
        appendTo: '[ng-app]',

        // TODO: Refactor the highPriority section of this template once the new grid system is complete

        template:
          template ||
          `\
<div class="bl-card">
  <form
    class="bl-form"
    name="notesForm"
    ng-submit="notesForm.$valid && confirm(vm)">
    <div class="bl-card_section bl-card_section-padded-medium">
      <span class="bl-icon-edit ngdialog-icon"></span>
      <p class="ngdialog-text">${message}</p>
    </div>
    <div class="bl-card_section bl-card_section-padded-medium">
      <textarea ng-model="vm.bknote" class="bl-textarea" maxlength="400" />
    </div>
    <div class="high-priority_container bl-card_section bl-card_section-padded-small">

      <div class="high-priority_label">
        High Priority Request:
      </div>

      <div class="high-priority_toggle">
        <div class="bl-toggle">
          <input type="checkbox" ng-model="vm.hprFlag">
          <div class="bl-toggle-handle">
            <span class="bl-toggle-checked" data-text="On"></span>
            <span class="bl-toggle-unchecked" data-text="Off"></span>
          </div>
        </div>
      </div>

      <div class="high-priority_reason-label" ng-if="vm.hprFlag">
        Reason:
      </div>

      <div class="high-priority_reason" ng-if="vm.hprFlag">
        <select
          name="highPriorityReason"
          class="high-priority_reason-combo"
          ng-model="vm.hprReason"
          required>
          <option>Trials</option>
          <option>Expedited KU - Premium CU</option>
        </select>
      </div>

      <div
        class="high-priority_error"
        ng-show="notesForm.highPriorityReason.$error.required && notesForm.$submitted">
        Reason is mandatory
      </div>
    </div>
    <div class="bl-card_section_bottom">
      <div class="ngdialog-buttons">
        <button class="bl-button primary" type="submit">${confirmText}</button>
        <button class="bl-button" ng-click="closeThisDialog(0)">${cancelText}</button>
      </div>
    </div>
  </form>
</div>\
`,
      });
    },
  }));
